module.exports = __webpack_public_path__ + "static/media/boat-img-22.664dd3a2.jpg";